import type { ConstValues } from '../helpers.ts';
import { ComparisonType, type Intersect, type VideoMaxAdDurationTargetingType } from './targetingValuesTypes.ts';

export const VideoOption = {
  REWARDED_VIDEO: 'rewarded_video',
  MAX_AD_DURATION: 'adunit_max_duration_range',
  PRESENTATION_FORMAT: 'video_format',
  IN_STREAM_VIDEO_POSITION: 'screen_location',
  PLACEMENT: 'video_plcmt',
  VIDEO_SKIPABILITY: 'skip',
} as const;
export type VideoOption = ConstValues<typeof VideoOption>;

export const RewardedVideoOption = {
  DOES_NOT_EQUAL: ComparisonType.DOES_NOT_EQUAL,
  EQUALS: ComparisonType.EQUALS,
} as const;
export type RewardedVideoOptionKeys = ConstValues<typeof RewardedVideoOption>;

export const VideoSkipabilityOption = {
  EQUALS: ComparisonType.EQUALS,
} as const;
export type VideoSkipabilityOptionKey = ConstValues<typeof VideoSkipabilityOption>;

export const VideoSkipabilityValue = {
  SKIPPABLE: '1',
  NON_SKIPPABLE: '0',
} as const;
export type VideoSkipabilityValue = ConstValues<typeof VideoSkipabilityValue>;

export type AdDurationOption = string | null;

export const payloadVideoTypes: Exclude<
  VideoOption,
  typeof VideoOption.MAX_AD_DURATION | typeof VideoOption.REWARDED_VIDEO | typeof VideoOption.VIDEO_SKIPABILITY
>[] = [VideoOption.PRESENTATION_FORMAT, VideoOption.IN_STREAM_VIDEO_POSITION, VideoOption.PLACEMENT];

export type VideoData = {
  [VideoOption.MAX_AD_DURATION]?: MaxAdDurationDataPayload | null;
  [VideoOption.PRESENTATION_FORMAT]?: VideoDataPayload | null;
  [VideoOption.IN_STREAM_VIDEO_POSITION]?: VideoDataPayload | null;
  [VideoOption.REWARDED_VIDEO]?: RewardedVideoPayload | null;
  [VideoOption.PLACEMENT]?: VideoDataPayload | null;
  [VideoOption.VIDEO_SKIPABILITY]?: VideoSkipabilityPayload | null;
};

export type VideoFormState = {
  [VideoOption.MAX_AD_DURATION]: MaxAdDurationStatePayload | null;
  [VideoOption.PRESENTATION_FORMAT]: VideoStatePayload;
  [VideoOption.IN_STREAM_VIDEO_POSITION]: VideoStatePayload;
  [VideoOption.REWARDED_VIDEO]: RewardedVideoPayload | null;
  [VideoOption.PLACEMENT]: VideoStatePayload;
  [VideoOption.VIDEO_SKIPABILITY]: VideoSkipabilityPayload | null;
};

export type VideoStatePayload = {
  op: Intersect;
  val: Set<string>;
};

export type MaxAdDurationStatePayload = {
  type: VideoMaxAdDurationTargetingType;
  start: AdDurationOption;
  end: AdDurationOption;
};

export type RewardedVideoPayload = {
  op: RewardedVideoOptionKeys;
  val: string;
};

export type VideoSkipabilityPayload = {
  op: VideoSkipabilityOptionKey;
  val: VideoSkipabilityValue;
};

export type VideoDataPayload = {
  op: Intersect;
  val: string;
};

export type MaxAdDurationDataPayload = {
  start: string;
  end: string | null;
};

export type TypeParams =
  | MaxAdDurationStatePayload
  | RewardedVideoPayload
  | VideoSkipabilityPayload
  | VideoStatePayload
  | null;
